<era-panel>
  <era-panel-header>
    <era-title [isDetail]="true">
      <span title
            i18n>Details</span>
      <div right
           class="d-flex align-items-center">
        <small class="mx-3">Last seen:
          {{ $safeNavigationMigration(selectedDevice()?.lastSeen) | date: 'medium' }}</small>
        <h3 class="title text-primary">
          <fa-icon [icon]="['fab', 'apple']"></fa-icon>
        </h3>
      </div>
    </era-title>
    <ul class="nav nav-tabs-sm ps-3 border-bottom">
      <li class="nav-item ps-0">
        <a class="nav-link"
           [routerLink]="['./info']"
           [routerLinkActive]="['active']">Info</a>
      </li>
      <li class="nav-item">
        <a class="nav-link"
           [routerLink]="['./timeline']"
           [routerLinkActive]="['active']">Timeline</a>
      </li>
      <li class="nav-item">
        <a class="nav-link"
           [routerLink]="['./profiles']"
           [routerLinkActive]="['active']">Profiles</a>
      </li>
      <li class="nav-item">
        <a class="nav-link"
           [routerLink]="['./apps']"
           [routerLinkActive]="['active']">Apps &amp; Books</a>
      </li>
      <li class="nav-item">
        <a class="nav-link"
           [routerLink]="['./security']"
           [routerLinkActive]="['active']">Security</a>
      </li>
      <li class="nav-item">
        <a class="nav-link"
           [routerLink]="['./updates']"
           [routerLinkActive]="['active']">Updates</a>
      </li>
      @if (features.devices?.details?.settings?.enabled) {
        <li class="nav-item">
          <a class="nav-link"
             [routerLink]="['./settings']"
             [routerLinkActive]="['active']">Settings</a>
        </li>
      }
      <li class="nav-item">
        <a class="nav-link"
           [routerLink]="['./admin']"
           [routerLinkActive]="['active']">Admin</a>
      </li>
      @if (features.devices?.notes?.enabled) {
        <li class="nav-item">
          <a class="nav-link"
             [routerLink]="['./notes']"
             [routerLinkActive]="['active']">Notes</a>
        </li>
      }
      <li class="nav-item">
        <a class="nav-link"
           [routerLink]="['./certificates']"
           [routerLinkActive]="['active']">Certificates</a>
      </li>
      <li class="nav-item ms-auto my-auto pe-0">
        <ml-mdm-apple-device-power></ml-mdm-apple-device-power>
      </li>
    </ul>
  </era-panel-header>
  <router-outlet></router-outlet>
</era-panel>